// SOURCE => https://gist.github.com/n0m4dz/77f08d3de1b9115e905c
const isKeyExistInLocalStorage = (query) => {
  for (const key in localStorage) {
    if (Object.prototype.hasOwnProperty.call(localStorage, key)) {
      if (key.match(query)) {
        return key
      }
    }
  }
  return false
}

export const getUserDataFromLocalStorage = () => {
  const userDataKey = isKeyExistInLocalStorage(/^CognitoIdentityServiceProvider.*userData$/)
  if (userDataKey) {
    const userData = JSON.parse(localStorage.getItem(userDataKey))
    return userData
  }
  return null
}

export const getJWTToken = () => {
  const jwtTokenKey = isKeyExistInLocalStorage(/^CognitoIdentityServiceProvider.*idToken$/)
  if (jwtTokenKey) {
    const jwtToken = localStorage.getItem(jwtTokenKey)
    return jwtToken
  }
  return null
}
